import { object, string } from "yup"
import { toast } from "react-toastify"
import BusinessInfo from "./views/BusinessInfo"
import AdditionalDocuments from "./views/ProprietorInfo"
import OtherInfo from "./views/OtherInfo"
import { format } from "date-fns"

export default [
  {
    id: "business_info",
    component: BusinessInfo,
    initialValues: {
      business_name1: "",
      business_name2: "",
      business_name3: "",
      business_name4: "",
      business_nature: "",
      address: "",
      country: "",
      city: "",
      state: "",
      other_business_nature: "",
      success_status: "",
    },
    validationSchema: object().shape({
      business_name1: string().required("Provide a sample Business Name"),
      business_name2: string().required("Provide a sample Business Name"),
      business_name3: string().required("Provide a sample Business Name"),
      business_name4: string().required("Provide a sample Business Name"),
      business_nature: string().required("Kindly indicate type of Business"),
      address: string().required("Provide your business address"),
      country: string().required("Required"),
      city: string()
        .matches(/^[a-zA-Z\s]*$/, "City is invalid")
        .required("Indicate city where business location"),
      state: string().required("Kindly indicate state where business location"),
    }),
    actionLabel: "Next",
    onAction: async (sectionValues, formValues) => {
      const fields = {
        business_name1: sectionValues.business_name1,
        business_name2: sectionValues.business_name2,
        business_name3: sectionValues.business_name3,
        business_name4: sectionValues.business_name4,
        business_nature: sectionValues.business_nature,
        address: sectionValues.address,
        country: sectionValues.country,
        city: sectionValues.city,
        state: sectionValues.state,
        other_business_nature: sectionValues.other_business_nature,
      }
      await fetch(
        `${process.env.DIY_BASE_URL}/api/order/v1/BusinessName/step1`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${localStorage.getItem("dd_token")}`,
          },
          body: JSON.stringify(fields),
        }
      )
      .then((response) => {
        if (!response.ok) {
          throw new Error("HTTP status " + response.statusText)
        }
        return response.json()
      })
      .then((response) => {
        localStorage.setItem("orderReference", response.orderReference)
      })
      .catch((error) => {
        console.error(error)
        throw new Error("An error occurred in the form")
      })
    },
  },
  {
    id: "other_info",
    component: OtherInfo,
    initialValues: {
      firstname: "",
      lastname: "",
      gender: "",
      proprietor_address: "",
      proprietor_state: "",
      proprietor_city: "",
      proprietor_email: "",
      proprietor_phone: "",
      nationality: "",
      dob: "",
      occupation: "",
      identity_type: "",
      identity_number: "",
      identity: "",
      signature: "",
      passport: "",
    },
    validationSchema: object().shape({
      firstname: string().required("Required"),
      lastname: string().required("Required"),
      gender: string().required("Required"),
      proprietor_email: string()
        .email("Must be a valid email address")
        .required("Required"),
      proprietor_phone: string()
        .matches(/^[0-9]{11}$/, "This phone number is Invalid")
        .required("Required"),
      proprietor_address: string().required("Required"),
      proprietor_state: string().required("Required"),
      proprietor_city: string()
        .matches(/^[A-Za-z]+$/, "City is invalid")
        .required("Required"),
      nationality: string().required("Required"),
      dob: string().required("Date of birth is required"),
      occupation: string().required("Occupation is required"),
      identity_type: string().required("Required"),
      identity_number: string().required("Required"),
      identity: string().required("Required"),
      signature: string().required("required"),
      passport: string().required("required"),
    }),
    actionLabel: "Next",
    onAction: async (sectionValues, formValues) => {
      const fields = {
        firstname: sectionValues.firstname,
        lastname: sectionValues.lastname,
        gender: sectionValues.gender,
        proprietor_address: sectionValues.proprietor_address,
        proprietor_state: sectionValues.proprietor_state,
        proprietor_city: sectionValues.proprietor_city,
        proprietor_email: sectionValues.proprietor_email,
        proprietor_phone: sectionValues.proprietor_phone,
        nationality: parseInt(sectionValues.nationality),
        dob: format(new Date(sectionValues.dob), "yyyy-MM-dd"),
        occupation: sectionValues.occupation,
        identity_type: sectionValues.identity_type,
        identity_number: sectionValues.identity_number,
        identity: {
          name: sectionValues.identity,
        },
        signature: {
          name: sectionValues.signature,
        },
        passport: {
          name: sectionValues.passport,
        },
      }

      await fetch(
        `${
          process.env.DIY_BASE_URL
        }/api/order/v1/BusinessName/step2?order-ref=${localStorage.getItem(
          "orderReference"
        )}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${localStorage.getItem("dd_token")}`,
          },
          body: JSON.stringify(fields),
        }
      )
        .then((response) => {
          if (!response.ok) {
            throw new Error("HTTP status " + response.statusText)
          }
         return response.json()
        })
        .then((response) => {
          console.log(response)
        })
        .catch((error) => {
          console.error(error)
           toast.error(error.message, { autoClose: 3000 })
          // return []
        })
    },
  },
  {
    id: "additional_documents",
    component: AdditionalDocuments,
    initialValues: {
      proprietor_company: "",
      company_name: "",
      company_address: "",
      company_country: "",
      company_state: "",
      company_city: "",
      rc_number: "",
      representative_name: "",
      representative_designation: "",
      representative_address: "",
      representative_country: "",
      representative_state: "",
      representative_city: "",
      representative_type: "",
      representative_number: "",
      representative_identity: "",
      cac_certificate: "",
      cac_certificate_name: "",
      representative_identity_name: "",
    },
    validationSchema: object().shape({
      proprietor_company: string().required("Required"),
    }),
    actionLabel: "Confirm",
  },
]
